import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Background Removal";
const API_PATH = "/infer/background-remover";

const callBackgroundRemoval = async (
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		// 결과가 투명 PNG이므로 Smart Object 배치 시 투명 영역이 잘리지 않도록 귀퉁이 alpha 보정
		preventSmartObjectTrim: true,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				input_images: [imageBase64],
				tool_document_id,
				jwt,
			};
			return fetchBackgroundRemoval(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchBackgroundRemoval(
	params: {
		input_images: string[];
		tool_document_id: string;
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchInferenceJob({
		params,
		executionContext,
		messageId,
		apiPath: API_PATH,
		statusEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace(API_PATH, "")}/status/${jobId}`,
		resultEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace(API_PATH, "")}/result/${jobId}`,
		cancelEndpoint: (apiUrl, jobId) => ({
			url: `${apiUrl.replace(API_PATH, "")}/cancel/${jobId}`,
			method: "POST",
		}),
		extractResult: (data) => data.image_base64,
		useGatewayUrl: true,
	});
}

export function useListenBackgroundRemovalMessage() {
	useListenFromRenderer([
		{
			key: "backgroundRemoval",
			onMessage: async (message) => {
				const success = await callBackgroundRemoval(
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
